import { END_POINTS } from '../helpers';
import { BlogData, CommonBody } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

type GetBlogsTypeResponse = {
  count: number;
  data: BlogData[];
};

export const blogApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBlogs: builder.query<
      CommonResponse & { data: GetBlogsTypeResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getBlog}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
    }),

    deleteBlog: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteBlog}/${id}`,
        method: 'DELETE',
      }),
    }),
    getBlogById: builder.query<CommonResponse & { data: BlogData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getBlogById}/${id}`,
        method: 'GET',
      }),
    }),

    addBlog: builder.mutation<CommonResponseType & { data: BlogData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addBlog}`,
        method: 'POST',
        body,
      }),
    }),
    updateBlog: builder.mutation<
      CommonResponseType & { data: BlogData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateBlog}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddBlogMutation,
  useUpdateBlogMutation,
  useLazyGetBlogsQuery,
  useLazyDeleteBlogQuery,
  useLazyGetBlogByIdQuery,
} = blogApi;
